export const SummaryOpportunity = {
    'metadata': {},
    'show_edited': {},
    'toggle': {},
    'output_toggle': {},
    'footer': {},
    'header': [
        {
            'parent': {
                'parent_field': 'sku_id',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'sku_id',
                'section': 'display',
                'order': 0,
                'is_sticky_column': false,
                'is_visible': false,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': null,
                'prefix_label': null,
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': 'ppg_id',
                'level': 2,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'ppg_id',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'ppg_id',
                'section': 'display',
                'order': 0,
                'is_sticky_column': false,
                'is_visible': false,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': null,
                'prefix_label': null,
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 1,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'ppg',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'PPG',
                'section': 'display',
                'order': 1,
                'is_sticky_column': true,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': null,
                'prefix_label': null,
                'suffix_label': '',
                'number_format': '',
                'field_format': 'TEXT',
                'datatype': 'STRING',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 1,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'sku',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'SKU',
                'section': 'display',
                'order': 2,
                'is_sticky_column': true,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': null,
                'prefix_label': null,
                'suffix_label': '',
                'number_format': '',
                'field_format': 'TEXT',
                'datatype': 'STRING',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': 'ppg',
                'level': 2,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'brand',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Brand',
                'section': 'display',
                'order': 3,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': null,
                'prefix_label': null,
                'suffix_label': '',
                'number_format': '',
                'field_format': 'TEXT',
                'datatype': 'STRING',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'price_change',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Price Change',
                'section': 'opportunityflag',
                'order': 4,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': '',
                'prefix_label': '',
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'distribution',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Distribution',
                'section': 'opportunityflag',
                'order': 5,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': '',
                'prefix_label': '',
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': 'green',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'simplification',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Delist',
                'section': 'opportunityflag',
                'order': 6,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': '',
                'prefix_label': '',
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': 'lightgrey',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'renovation',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Renovation',
                'section': 'opportunityflag',
                'order': 7,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': '',
                'prefix_label': '',
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': 'blue',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'innovation',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Innovation',
                'section': 'opportunityflag',
                'order': 8,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': '',
                'prefix_label': '',
                'suffix_label': '',
                'number_format': '',
                'field_format': 'NUMBER',
                'datatype': 'INTEGER',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        },
        {
            'parent': {
                'parent_field': 'comments',
                'toggle_tag': [],
                'output_toggle_tag': [],
                'alias': 'Comments',
                'section': 'display',
                'order': 9,
                'is_sticky_column': false,
                'is_visible': true,
                'is_global_input_enable': false,
                'is_cf_enable': false,
                'is_info_enable': false,
                'info_details': '0',
                'is_input_enable': false,
                'currency_label': '',
                'prefix_label': '',
                'suffix_label': '',
                'number_format': '',
                'field_format': 'TEXT',
                'datatype': 'STRING',
                'is_sort_enable': false,
                'default_sort_order': 'ASC_',
                'has_footer': false,
                'formula': '',
                'self_change_formula': '',
                'linked_to_field': '',
                'child_field': '',
                'level': 0,
                'is_part_of_payload': false,
                'default_value': 0,
                'default_value_field': '',
                'static_values': [],
                'is_forward_to_children': false,
                'is_reset_needed': false,
                'fill_color': '',
                'has_border': true,
                'db_field_map': ''
            },
            'children': []
        }
    ],
    'legend': {
        'metadata': []
    },
    'summary_strip': {
        'metadata': []
    },
    'row': [
        {
            'parent': {
                'data': {
                    'ppg_id': 48,
                    'sku_id': 'NAN',
                    'overall_opportunity': [
                        4,
                        3
                    ],
                    'ppg': 'SNICKERS_BARS / COUNTLINES_SINGLE_PAK_18.3x2',
                    'sku': 'NAN',
                    'brand': 'SNICKERS',
                    'comments': [],
                    'parent_index': -1,
                    'index': 1,
                    'price_change': true,
                    'delist': false,
                    'renovation': false,
                    'distribution': true,
                    'innovation': false
                }
            },
            'children': [
                {
                    'parent': {
                        'data': {
                            'ppg_id': 48,
                            'sku_id': 50,
                            'overall_opportunity': [
                                4,
                                3
                            ],
                            'ppg': 'SNICKERS_BARS / COUNTLINES_SINGLE_PAK_18.3x2',
                            'sku': 'SNICKERS_BARS / COUNTLINES_SINGLE_SNICKERS_CARML_MLK_NGT_PNTBTTR_PND_PAK_18.3x2',
                            'brand': 'SNICKERS',
                            'comments': [],
                            'parent_index': 1,
                            'index': 3,
                            'price_change': true,
                            'delist': true,
                            'renovation': true,
                            'distribution': true,
                            'innovation': false
                        }
                    },
                    'children': []
                }
            ]
        },
        {
            'parent': {
                'data': {
                    'ppg_id': 50,
                    'sku_id': 'NAN',
                    'overall_opportunity': [
                        2,
                        1
                    ],
                    'ppg': 'SNICKERS_BARS / COUNTLINES_CB_MULTI_DOOS_20x10',
                    'sku': 'NAN',
                    'brand': 'SNICKERS',
                    'comments': [],
                    'parent_index': -1,
                    'index': 2,
                    'price_change': true,
                    'delist': false,
                    'renovation': false,
                    'distribution': true,
                    'innovation': false
                }
            },
            'children': []
        }
    ]
};

export const BulkCommentsData = {
    'data':
        [
            {
                'parent': {
                    'data': {
                        'product_field_1_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_ZAK_333x1',
                        'product_field_1': 77,
                        'imgUrl': '',
                        'key': 'product_field_1',
                        'product_field_2_name': 'NAN',
                        'product_field_2': 'NAN',
                        'comments': [
                            {
                                'pk_id': 15,
                                'comment_text': 'test6',
                                'comment_user': 5,
                                'comment_user_name': 'testuser2@srmppa.com',
                                'created_at': '2023-09-20T18:14:33.692517Z',
                                'updated_at': '2023-09-20T18:14:33.692538Z',
                                'is_edited': false
                            },
                            {
                                'pk_id': 14,
                                'comment_text': 'test5',
                                'comment_user': 5,
                                'comment_user_name': 'testuser2@srmppa.com',
                                'created_at': '2023-09-20T18:14:29.171339Z',
                                'updated_at': '2023-09-20T18:14:29.171360Z',
                                'is_edited': false
                            },
                            {
                                'pk_id': 13,
                                'comment_text': 'test3 testss',
                                'comment_user': 5,
                                'comment_user_name': 'testuser2@srmppa.com',
                                'created_at': '2023-09-20T18:02:10.688100Z',
                                'updated_at': '2023-09-20T18:03:48.015357Z',
                                'is_edited': true
                            },
                            {
                                'pk_id': 2,
                                'comment_text': 'test1',
                                'comment_user': 5,
                                'comment_user_name': 'testuser2@srmppa.com',
                                'created_at': '2023-09-20T17:09:00.660975Z',
                                'updated_at': '2023-09-20T17:09:00.660999Z',
                                'is_edited': false
                            }
                        ],
                        'index': 1,
                        'parent_index': -1
                    }
                },
                'children': [
                    {
                        'parent': {
                            'data': {
                                'product_field_1_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_ZAK_333x1',
                                'product_field_1': 82,
                                'imgUrl': '',
                                'id': 77,
                                'key': 'product_field_2',
                                'product_field_2_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_SNICKERS_PINDA_ZAK_333x1',
                                'product_field_2': 82,
                                'comments': [
                                    {
                                        'pk_id': 4,
                                        'comment_text': 'child1',
                                        'comment_user': 5,
                                        'comment_user_name': 'testuser2@srmppa.com',
                                        'created_at': '2023-09-20T17:09:09.199233Z',
                                        'updated_at': '2023-09-20T17:09:09.199258Z',
                                        'is_edited': false
                                    }
                                ],
                                'index': 1,
                                'parent_index': 1
                            },
                            'children': []
                        }
                    },
                    {
                        'parent': {
                            'data': {
                                'product_field_1_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_ZAK_333x1',
                                'product_field_1': 77,
                                'imgUrl': '',
                                'id': 77,
                                'key': 'product_field_2',
                                'product_field_2_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_SNICKERS_PINDA_ZAK_333x1',
                                'product_field_2': '1',
                                'comments': [],
                                'index': 1,
                                'parent_index': 1
                            },
                            'children': []
                        }
                    },
                    {
                        'parent': {
                            'data': {
                                'product_field_1_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_ZAK_333x1',
                                'product_field_1': 77,
                                'imgUrl': '',
                                'id': 77,
                                'key': 'product_field_2',
                                'product_field_2_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_SNICKERS_PINDA_ZAK_333x1',
                                'product_field_2': '1',
                                'comments': [],
                                'index': 1,
                                'parent_index': 1
                            },
                            'children': []
                        }
                    }, {
                        'parent': {
                            'data': {
                                'product_field_1_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_ZAK_333x1',
                                'product_field_1': 77,
                                'imgUrl': '',
                                'id': 77,
                                'key': 'product_field_2',
                                'product_field_2_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_SNICKERS_PINDA_ZAK_333x1',
                                'product_field_2': '1',
                                'comments': [],
                                'index': 1,
                                'parent_index': 1
                            },
                            'children': []
                        }
                    }, {
                        'parent': {
                            'data': {
                                'product_field_1_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_ZAK_333x1',
                                'product_field_1': 77,
                                'imgUrl': '',
                                'id': 77,
                                'key': 'product_field_2',
                                'product_field_2_name': 'SNICKERS_BARS / COUNTLINES_CB_MINI_SNICKERS_PINDA_ZAK_333x1',
                                'product_field_2': '1',
                                'comments': [],
                                'index': 1,
                                'parent_index': 1
                            },
                            'children': []
                        }
                    }
                ]
            }
        ]
};